<template>
    <div class="main-block request-management">
        <div class="div col-12 p-0 d-flex align-items-start">
            <h4 class="">{{ $t('title.partners') }}</h4>
        </div>
        <div class="scrollable-block">
            <div class="col-12 row mt-3 m-0 p-0" style="min-height: 90%">
                <crud-table :columns="columns" :list-url="listUrl" ref="application-table"
                            v-on:refresh="resetFilter">
                    <b-button variant="primary" @click="$router.go(-1)">
                        <b-icon icon="arrow-left" class="icon-style"></b-icon>
                    </b-button>
                    <b-button variant="primary" @click="handleUserAction">
                        <b-icon icon="person-plus" class="icon-style"></b-icon>
                    </b-button>
                    <!--                    <b-button variant="primary" @click="$router.push({ name: 'savedMondaycrmLeads' })">-->
                    <!--                        <b-icon icon="bookmark" class="ms-2"></b-icon>-->
                    <!--                    </b-button>-->
                    <template #cell(action)="{ item }">
                        <input type="checkbox" :value="item.owner" v-model="selectedUsers" class="mr-2" />
                    </template>
                    <!-- Display Created At Time -->
                    <template #cell(created_at)="{ item }">
                        <div>
                            <span>
                                {{ $global.utcDateToLocalDate(item.created_at) }}
                            </span>
                        </div>
                    </template>
                </crud-table>

            </div>
        </div>
    </div>
</template>

<script>
import { request } from "@/Util/Request";
import { Modal } from "bootstrap";

const FILTER_FORM = {
    integration_id: null // Adding the new filter for integration_id
};
const COLUMN_STATE = (self) => [
    { key: 'action', label: self.$t('title.action') },
    { key: 'name', label: self.$t('title.name'), sortable: true },
    { key: 'integration.name', label: self.$t('title.integration'), sortable: true },
    { key: 'objective_text', label: self.$t('title.objective_text'), sortable: true },
    { key: 'promotion_type_text', label: self.$t('title.promotion_type'), sortable: true },
    { key: 'life_cycle_status_code_text', label: self.$t('title.status'), sortable: true },
    { key: 'employee_responsible', label: self.$t('title.employee_responsible'), sortable: true },
    { key: 'creation_date', label: self.$t('title.created_at'), sortable: true }
];

export default {
    data() {
        return {
            selectedUsers: [], // Store selected Microsoft User IDs
            filters: { ...FILTER_FORM },
        };
    },
    mounted() {
        if(this.$route.query.id) {
            this.$refs['application-table'].handleCustomSearch(this.$route.query.id);
        }
    },
    methods: {
        async handleUserAction() {
            this.isLoading = true; // optional loading state if needed
            const payload = {
                owners: this.selectedUsers
            };

            try {
                const response = await request({
                    method: 'post',
                    url: '/admin/save/monday/leads',
                    data: payload,
                    headers: {
                        'Content-Type': 'application/json' // Content type for JSON data
                    }
                });

                if (response.status === true) {
                    this.$bvToast.toast('User stored successfully!', {
                        title: 'Success',
                        variant: 'success',
                        solid: true
                    });
                } else {
                    this.$bvToast.toast('User storage failed.', {
                        title: 'Error',
                        variant: 'danger',
                        solid: true
                    });
                }
            } catch (error) {
                console.error("Error storing user IDs:", error);
                this.errorMessage = error.response ? error.response.data.message : error.message;
                // You might also want to show an error toast
                this.$bvToast.toast(this.errorMessage, {
                    title: 'Error',
                    variant: 'danger',
                    solid: true
                });
            } finally {
                this.isLoading = false;
            }
        },
        resetFilter() {
            this.filters = { ...FILTER_FORM };
            this.$refs['application-table'].handleFilter({ filters: this.filters });
        },
        formatDate(dateString) {
            return new Date(dateString).toLocaleString();
        },
    },
    computed: {
        listUrl() {
            return `admin/sap/promotion/${this.$route.params.id || ''}`;
        },
        columns() {
            return COLUMN_STATE(this);
        }
    }
};
</script>
